import { ActionHandler } from '../../common/actions/core/action-handler';
import { Action } from '../../common/actions/core/action';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from './payment-progress.action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';

/* @ngInject */
export default class PaymentProgressController implements ActionHandler {
  public invoiceStep: boolean = true;

  constructor(private actionDispatcher: ActionDispatcherService) {}

  public $postLink() {
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }

  public setInvoiceStep(status: PaymentProgressStatus) {
    if (status == PaymentProgressStatus.INVOICE) {
      this.invoiceStep = true;
    } else {
      this.invoiceStep = false;
    }
  }

  handle(action: Action) {
    if (action instanceof PaymentProgressChangeAction) {
      this.setInvoiceStep(action.status);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/payment-progress/payment-progress.controller.ts